import { render } from "./Eye.vue?vue&type=template&id=0a8efae5"
import script from "./Eye.vue?vue&type=script&lang=js"
export * from "./Eye.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Eye.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a8efae5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a8efae5', __exports__)) {
    api.reload('0a8efae5', __exports__)
  }
  
  module.hot.accept("./Eye.vue?vue&type=template&id=0a8efae5", () => {
    api.rerender('0a8efae5', render)
  })

}


export default __exports__